export default {
  on: {
    pageInit: function () {
      var root = this.$el && this.$el[0] ? this.$el[0] : document;
      var input = root.querySelector('#amount-invest');
      var returns = root.querySelector('.iv__returns');
      var rateEl = root.querySelector('.iv__rate');
      var dailyEl = root.querySelector('.iv__return-daily');
      var weekEl = root.querySelector('.iv__week');
      var monthEl = root.querySelector('.iv__month');
      var maxroiEl = root.querySelector('.iv__maxroi');
      var capdaysEl = root.querySelector('.iv__capdays');
      var capnoteEl = root.querySelector('.iv__capnote');
      var note = root.querySelector('.totalReturn');
      var submit = root.querySelector('.investNowBTN');
      var chips = root.querySelectorAll('.iv__chip');
      var tiers = root.querySelectorAll('.iv__tier');
      var MIN = 50;
      var WEEK_DAYS = 5, MONTH_DAYS = 22;
      function tierRate(amount) {
        if (amount >= 5000)
          return 0.02;
        if (amount >= 1000)
          return 0.0175;
        if (amount >= 500)
          return 0.015;
        if (amount >= 250)
          return 0.0125;
        if (amount >= 100)
          return 0.01;
        if (amount >= 50)
          return 0.006;
        return 0;
      }
      function usd(n) {
        return '$' + Number(n).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      function syncChips(amount) {
        for (var i = 0; i < chips.length; i++) {
          var on = parseFloat(chips[i].getAttribute('data-amt')) === amount;
          chips[i].classList.toggle('iv__chip--on', on);
        }
      }
      function syncTiers(amount) {
        var activeMin = -1;
        if (!isNaN(amount) && amount >= MIN) {
          for (var i = 0; i < tiers.length; i++) {
            var m = parseFloat(tiers[i].getAttribute('data-min'));
            if (amount >= m && m > activeMin)
              activeMin = m;
          }
        }
        for (var j = 0; j < tiers.length; j++) {
          var on = parseFloat(tiers[j].getAttribute('data-min')) === activeMin;
          tiers[j].classList.toggle('iv__tier--on', on);
        }
      }
      function update() {
        var amount = parseFloat(input.value);
        var valid = !isNaN(amount) && amount >= MIN;
        if (valid) {
          var rate = tierRate(amount);
          var ratePct = (rate * 100).toFixed(2);
          var daily = amount * rate;
          rateEl.textContent = ratePct + '%';
          dailyEl.textContent = usd(daily);
          weekEl.textContent = usd(daily * WEEK_DAYS);
          monthEl.textContent = usd(daily * MONTH_DAYS);
          var maxRoi = amount * 2;
          var earnDays = Math.ceil(2 / rate);
          var calDays = Math.ceil(earnDays * 7 / 5);
          var months = (calDays / 30.44).toFixed(1).replace(/\.0$/, '');
          maxroiEl.textContent = usd(maxRoi);
          capdaysEl.textContent = '~' + calDays.toLocaleString() + ' days';
          capnoteEl.textContent = '\u2248 ' + months + ' months \xB7 weekdays only';
          capnoteEl.classList.remove('iv__capnote--warn');
          returns.style.display = 'block';
          note.innerHTML = 'Your ' + usd(amount) + ' earns <b>' + ratePct + '% daily</b> (tier-based) until it reaches the <b>2\xD7 cap</b> (' + usd(maxRoi) + ') \u2014 this is <b>not limited to 365 days</b>. The principal stays locked for <b>365 days</b>, after which it can be redeemed/sold at the gold market rate. Returns are credited <b>weekdays only (Mon\u2013Fri)</b>. Plus <b>5%</b> on every direct referral.';
          submit.classList.remove('disabled');
          submit.setAttribute('data-amount', amount);
          submit.setAttribute('data-days', '365');
        } else {
          returns.style.display = 'none';
          note.innerHTML = '';
          submit.classList.add('disabled');
          submit.removeAttribute('data-amount');
        }
        syncChips(valid ? amount : NaN);
        syncTiers(valid ? amount : NaN);
      }
      if (input)
        input.addEventListener('input', update);
      for (var i = 0; i < chips.length; i++) {
        chips[i].addEventListener('click', function () {
          input.value = this.getAttribute('data-amt');
          update();
          input.focus();
        });
      }
    }
  },
  id: 'e115ceac58',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page iv" data-name="invest">\n\n    <!-- Navbar -->\n    <div class="navbar iv__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back iv__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title iv__navbar-title">Invest</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content iv__content">\n\n      <!-- Plan hero -->\n      <div class="iv__plan">\n        <div class="iv__plan-glow"></div>\n        <div class="iv__plan-shine"></div>\n        <div class="iv__plan-head">\n          <div class="iv__plan-emblem">\n            <svg width="26" height="26" viewBox="0 0 32 32" fill="none">\n              <g transform="skewX(-10)">\n                <rect x="6" y="16" width="13" height="7" rx="1.5" fill="url(#ivb1)"/>\n                <rect x="17.5" y="16" width="13" height="7" rx="1.5" fill="url(#ivb2)"/>\n                <rect x="11.8" y="8" width="13" height="7" rx="1.5" fill="url(#ivb3)"/>\n              </g>\n              <defs>\n                <linearGradient id="ivb1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f0d488"/><stop offset="100%" stop-color="#b8923f"/></linearGradient>\n                <linearGradient id="ivb2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e6c878"/><stop offset="100%" stop-color="#a8853e"/></linearGradient>\n                <linearGradient id="ivb3" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f6e3a8"/><stop offset="100%" stop-color="#c9a969"/></linearGradient>\n              </defs>\n            </svg>\n          </div>\n          <div class="iv__plan-id">\n            <div class="iv__plan-name">XAUt Digital Gold</div>\n            <div class="iv__plan-sub">Backed by physical gold \xB7 999.9 fine</div>\n          </div>\n          <div class="iv__plan-live"><span class="iv__plan-live-dot"></span>Live</div>\n        </div>\n        <div class="iv__plan-stats">\n          <div class="iv__stat">\n            <div class="iv__stat-val">0.60\u20132.0%</div>\n            <div class="iv__stat-lbl">Daily ROI</div>\n          </div>\n          <div class="iv__stat-sep"></div>\n          <div class="iv__stat">\n            <div class="iv__stat-val">365</div>\n            <div class="iv__stat-lbl">Days Lock-in</div>\n          </div>\n          <div class="iv__stat-sep"></div>\n          <div class="iv__stat">\n            <div class="iv__stat-val">5%</div>\n            <div class="iv__stat-lbl">Referral</div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Pending-investment notice (shown by routes.js when last investment is processing) -->\n      <div class="iv__pending" style="display:none;">\n        <span class="iv__pending-ico">\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>\n        </span>\n        <div class="iv__pending-body">\n          <div class="iv__pending-title">Investment In Progress</div>\n          <div class="iv__pending-sub">Your previous investment is still being processed. You\'ll be able to make a new investment once it\'s activated.</div>\n        </div>\n      </div>\n\n      <!-- Amount card -->\n      <div class="iv__card">\n        <div class="iv__card-label">Investment Amount</div>\n        <div class="iv__amount-row">\n          <span class="iv__currency">$</span>\n          <input type="number" name="amount-invest" id="amount-invest"\n            min="50" max="500000000" step="1" placeholder="0.00"\n            inputmode="decimal" autocomplete="off"\n            class="iv__amount-input" />\n        </div>\n        <div class="iv__min-note">Minimum investment <b>$50</b></div>\n        <div class="iv__chips">\n          <button type="button" class="iv__chip" data-amt="50">$50</button>\n          <button type="button" class="iv__chip" data-amt="100">$100</button>\n          <button type="button" class="iv__chip" data-amt="500">$500</button>\n          <button type="button" class="iv__chip" data-amt="1000">$1,000</button>\n        </div>\n      </div>\n\n      <!-- Returns projection -->\n      <div class="iv__returns" style="display:none;">\n        <div class="iv__returns-head">\n          <span class="iv__returns-title">Estimated Daily Earnings</span>\n          <span class="iv__returns-badge"><span class="iv__rate">0.60%</span> / day</span>\n        </div>\n        <div class="iv__returns-range">\n          <span class="iv__return-daily">$0.00</span>\n          <span class="iv__return-per">/ day</span>\n        </div>\n        <div class="iv__proj">\n          <div class="iv__proj-item">\n            <div class="iv__proj-lbl">Weekly \xB7 5 days</div>\n            <div class="iv__proj-val iv__week">\u2014</div>\n          </div>\n          <div class="iv__proj-sep"></div>\n          <div class="iv__proj-item">\n            <div class="iv__proj-lbl">Monthly \xB7 ~22 days</div>\n            <div class="iv__proj-val iv__month">\u2014</div>\n          </div>\n        </div>\n\n        <div class="iv__cap">\n          <div class="iv__cap-item">\n            <div class="iv__cap-lbl">Max ROI \xB7 2\xD7</div>\n            <div class="iv__cap-val iv__maxroi">$0.00</div>\n            <div class="iv__cap-sub">200% of principal</div>\n          </div>\n          <div class="iv__cap-sep"></div>\n          <div class="iv__cap-item">\n            <div class="iv__cap-lbl">Est. Time to 2\xD7</div>\n            <div class="iv__cap-val iv__capdays">\u2014</div>\n            <div class="iv__cap-sub iv__capnote">weekdays only</div>\n          </div>\n        </div>\n\n        <p class="iv__returns-note totalReturn"></p>\n      </div>\n\n      <!-- Daily ROI tiers -->\n      <div class="iv__tiers">\n        <div class="iv__tiers-head">\n          <span class="iv__tiers-title">Daily ROI Tiers</span>\n          <span class="iv__tiers-sub">Higher tiers earn more</span>\n        </div>\n        <div class="iv__tier-list">\n          <div class="iv__tier" data-min="50">   <span class="iv__tier-rng">$50 \u2013 $99</span>      <span class="iv__tier-pct">0.60%</span></div>\n          <div class="iv__tier" data-min="100">  <span class="iv__tier-rng">$100 \u2013 $249</span>    <span class="iv__tier-pct">1.00%</span></div>\n          <div class="iv__tier" data-min="250">  <span class="iv__tier-rng">$250 \u2013 $499</span>    <span class="iv__tier-pct">1.25%</span></div>\n          <div class="iv__tier" data-min="500">  <span class="iv__tier-rng">$500 \u2013 $999</span>    <span class="iv__tier-pct">1.50%</span></div>\n          <div class="iv__tier" data-min="1000"> <span class="iv__tier-rng">$1,000 \u2013 $4,999</span><span class="iv__tier-pct">1.75%</span></div>\n          <div class="iv__tier" data-min="5000"> <span class="iv__tier-rng">$5,000 &amp; above</span> <span class="iv__tier-pct">2.00%</span></div>\n        </div>\n      </div>\n\n      <!-- Submit -->\n      <button class="iv__submit investNowBTN disabled" type="button">\n        <span>Invest Now</span>\n        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>\n      </button>\n\n      <div class="iv__tc">\n        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>\n        By investing you agree to our\n        <a href="#" class="popup-open" data-popup="#sheet--invest-tc">Terms &amp; Conditions</a>\n      </div>\n\n      <div class="iv__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ INVEST PAGE (iv__*) ════════ */
.iv { background: #0A0A0B !important; }
.iv__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(48px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.iv__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.iv__navbar .navbar-bg { background: transparent !important; }
.iv__navbar-title { color: var(--gold) !important; font-weight: 700; }
.iv__back { color: rgba(201,169,105,0.85) !important; }

/* Pending-investment notice */
.iv__pending {
  display: flex; align-items: flex-start; gap: 12px;
  margin-top: 14px; padding: 15px 16px;
  background: linear-gradient(150deg, rgba(251,191,36,0.12), rgba(251,191,36,0.04));
  border: 1px solid rgba(251,191,36,0.3); border-radius: 16px;
}
.iv__pending-ico {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 11px;
  background: rgba(251,191,36,0.14); border: 1px solid rgba(251,191,36,0.28); color: #fbbf24;
  display: flex; align-items: center; justify-content: center;
}
.iv__pending-title { font-size: 14px; font-weight: 800; color: #fbbf24; }
.iv__pending-sub { font-size: 12px; color: rgba(255,255,255,0.6); line-height: 1.55; margin-top: 4px; }

/* Plan hero */
.iv__plan {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(201,169,105,0.16) 0%, transparent 55%),
    linear-gradient(150deg, #221b0d 0%, #161109 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 22px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 16px 36px -18px rgba(0,0,0,0.8);
}
.iv__plan::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
.iv__plan-glow {
  position: absolute; top: -50px; right: -40px; width: 170px; height: 170px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%);
}
@keyframes iv-shine { 0% { transform: translateX(-130%) skewX(-18deg); } 100% { transform: translateX(420%) skewX(-18deg); } }
.iv__plan-shine { position: absolute; inset: 0; overflow: hidden; border-radius: 22px; pointer-events: none; }
.iv__plan-shine::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 42%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent);
  animation: iv-shine 5.5s ease-in-out infinite 1.5s;
}
.iv__plan-head { position: relative; z-index: 1; display: flex; align-items: center; gap: 11px; }
.iv__plan-emblem {
  width: 46px; height: 46px; border-radius: 13px; flex-shrink: 0;
  background: linear-gradient(145deg, rgba(201,169,105,0.24), rgba(201,169,105,0.08));
  border: 1px solid rgba(201,169,105,0.32);
  display: flex; align-items: center; justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.20);
}
.iv__plan-id { flex: 1; min-width: 0; }
.iv__plan-name { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -0.01em; }
.iv__plan-sub { font-size: 11px; color: rgba(255,255,255,0.42); margin-top: 2px; }
.iv__plan-live {
  display: inline-flex; align-items: center; gap: 5px; flex-shrink: 0;
  font-size: 10px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.22);
  border-radius: 20px; padding: 3px 8px;
}
.iv__plan-live-dot { width: 5px; height: 5px; border-radius: 50%; background: #4ADE80; box-shadow: 0 0 5px rgba(74,222,128,0.6); }
.iv__plan-stats {
  position: relative; z-index: 1;
  display: flex; align-items: center;
  margin-top: 16px; padding-top: 15px;
  border-top: 1px solid rgba(201,169,105,0.14);
}
.iv__stat { flex: 1; text-align: center; }
.iv__stat-val { font-size: 16px; font-weight: 800; color: #C9A969; line-height: 1; letter-spacing: -0.01em; }
.iv__stat-lbl { font-size: 10px; color: rgba(255,255,255,0.42); margin-top: 4px; font-weight: 500; }
.iv__stat-sep { width: 1px; height: 30px; background: rgba(201,169,105,0.16); }

/* Amount card */
.iv__card {
  margin-top: 14px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 20px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.10), 0 14px 30px -18px rgba(0,0,0,0.7);
}
.iv__card-label { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.55); margin-bottom: 12px; }
.iv__amount-row {
  display: flex; align-items: center; gap: 4px;
  background: var(--bg-input);
  border: 1.5px solid rgba(201,169,105,0.22);
  border-radius: 14px; padding: 0 16px; height: 64px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.iv__amount-row:focus-within { border-color: var(--gold); box-shadow: 0 0 0 3px rgba(201,169,105,0.12); }
.iv__currency { font-size: 24px; font-weight: 700; color: rgba(201,169,105,0.75); }
.iv__amount-input {
  flex: 1; min-width: 0; height: 100%;
  background: transparent !important; border: none; outline: none;
  color: #fff; font-size: 28px !important; font-weight: 800; letter-spacing: -0.01em !important;
  -webkit-appearance: none; appearance: none;
}
.iv__amount-input::placeholder { color: rgba(255,255,255,0.22); }
.iv__amount-input::-webkit-outer-spin-button,
.iv__amount-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.iv__min-note { font-size: 11px; color: rgba(255,255,255,0.38); margin-top: 8px; }
.iv__min-note b { color: rgba(201,169,105,0.85); }
.iv__chips { display: flex; gap: 8px; margin-top: 14px; }
.iv__chip {
  flex: 1; height: 38px; border-radius: 11px;
  background: rgba(201,169,105,0.08);
  border: 1px solid rgba(201,169,105,0.18);
  color: rgba(201,169,105,0.90); font-size: 12.5px; font-weight: 700; cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s, transform 0.1s;
}
.iv__chip:active { transform: scale(0.95); }
.iv__chip--on {
  background: linear-gradient(135deg, rgba(201,169,105,0.30), rgba(201,169,105,0.14));
  border-color: rgba(201,169,105,0.5); color: #f3e0a8;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.25);
}

/* Returns projection */
.iv__returns {
  margin-top: 14px;
  background:
    radial-gradient(100% 80% at 100% 0%, rgba(74,222,128,0.07) 0%, transparent 55%),
    linear-gradient(155deg, #14160f 0%, #111210 100%);
  border: 1px solid rgba(74,222,128,0.18);
  border-radius: 20px; padding: 18px;
}
.iv__returns-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.iv__returns-title { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.55); }
.iv__returns-badge {
  font-size: 10px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.22);
  border-radius: 20px; padding: 2px 8px;
}
.iv__returns-range { display: flex; align-items: baseline; gap: 7px; }
.iv__return-daily { font-size: 26px; font-weight: 800; color: #4ADE80; letter-spacing: -0.01em; }
.iv__return-per { font-size: 12px; color: rgba(255,255,255,0.40); font-weight: 500; }
.iv__rate { font-weight: 800; }
.iv__proj {
  display: flex; align-items: center;
  margin-top: 14px; padding-top: 14px;
  border-top: 1px solid rgba(255,255,255,0.06);
}
.iv__proj-item { flex: 1; min-width: 0; }
.iv__proj-lbl { font-size: 10.5px; color: rgba(255,255,255,0.40); font-weight: 500; }
.iv__proj-val { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.85); margin-top: 3px; }
.iv__proj-sep { width: 1px; height: 30px; background: rgba(255,255,255,0.08); margin: 0 12px; }

.iv__cap {
  display: flex; align-items: stretch;
  margin-top: 12px; padding: 12px 14px;
  background: linear-gradient(150deg, rgba(201,169,105,0.14), rgba(201,169,105,0.04));
  border: 1px solid rgba(201,169,105,0.26); border-radius: 14px;
}
.iv__cap-item { flex: 1; min-width: 0; }
.iv__cap-lbl { font-size: 10.5px; color: rgba(201,169,105,0.80); font-weight: 600; letter-spacing: 0.02em; }
.iv__cap-val { font-size: 17px; font-weight: 800; color: #dfc288; margin-top: 3px; letter-spacing: -0.01em; }
.iv__cap-sub { font-size: 9.5px; color: rgba(255,255,255,0.42); margin-top: 2px; }
.iv__cap-sub.iv__capnote--warn { color: rgba(239,68,68,0.85); }
.iv__cap-sep { width: 1px; background: rgba(201,169,105,0.22); margin: 0 12px; }
.iv__returns-note { font-size: 11.5px; color: rgba(255,255,255,0.50); line-height: 1.5; margin: 12px 0 0; }
.iv__returns-note b { color: rgba(201,169,105,0.90); font-weight: 700; }

/* Daily ROI tiers */
.iv__tiers {
  margin-top: 14px;
  background: linear-gradient(160deg, rgba(255,255,255,0.045), rgba(255,255,255,0.015));
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 18px; padding: 14px 14px 8px;
}
.iv__tiers-head { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 10px; }
.iv__tiers-title { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.92); }
.iv__tiers-sub { font-size: 10.5px; color: rgba(255,255,255,0.40); }
.iv__tier-list { display: flex; flex-direction: column; gap: 2px; }
.iv__tier {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 11px; border-radius: 11px;
  border: 1px solid transparent;
  transition: background .18s ease, border-color .18s ease, transform .18s ease;
}
.iv__tier-rng { font-size: 12px; color: rgba(255,255,255,0.62); font-variant-numeric: tabular-nums; }
.iv__tier-pct { font-size: 12.5px; font-weight: 700; color: rgba(201,169,105,0.85); font-variant-numeric: tabular-nums; }
.iv__tier--on {
  background: linear-gradient(150deg, rgba(201,169,105,0.18), rgba(201,169,105,0.06));
  border-color: rgba(201,169,105,0.42);
  box-shadow: 0 6px 16px -10px rgba(201,169,105,0.6);
}
.iv__tier--on .iv__tier-rng { color: rgba(255,255,255,0.95); font-weight: 600; }
.iv__tier--on .iv__tier-pct { color: #dfc288; }

/* Submit */
@keyframes iv-btn-shine { 0% { left: -60%; } 55%,100% { left: 130%; } }
.iv__submit {
  position: relative; overflow: hidden;
  width: 100%; height: 54px; margin-top: 18px; border: none; border-radius: 15px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 15px; font-weight: 800;
  display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
  transition: transform 0.14s, opacity 0.2s, filter 0.2s;
}
.iv__submit::after {
  content: ''; position: absolute; top: 0; bottom: 0; left: -60%; width: 38%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent);
  transform: skewX(-20deg); animation: iv-btn-shine 4s ease-in-out infinite;
}
.iv__submit span, .iv__submit svg { position: relative; z-index: 1; }
.iv__submit:active { transform: scale(0.98); }
.iv__submit.disabled {
  opacity: 0.45; filter: grayscale(0.3); pointer-events: none; box-shadow: none;
}
.iv__submit.disabled::after { display: none; }

.iv__tc {
  display: flex; align-items: center; justify-content: center; gap: 6px; flex-wrap: wrap;
  margin-top: 16px; font-size: 11.5px; color: rgba(255,255,255,0.42); text-align: center;
}
.iv__tc svg { color: rgba(201,169,105,0.55); }
.iv__tc a { color: var(--gold); font-weight: 600; }
.iv__end-gap { height: 50px; }
`,
  styleScoped: false
};